import React, { useEffect, useRef, useState } from 'react'
import { Iprops } from './sharedquotesinterface'
import { Popup } from "@progress/kendo-react-popup";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import SharedQuotes from './sharedquotes';
import { useTranslation } from 'react-i18next';
import { RESOURCE } from '../../../const/resource';
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from '../../../state/features/header';
import helperfunctions from '../../../utils/helperfunctions';
import QuantityColumn from '../Quantity';

const ActionCheckboxDetail = (item: any, props: any) => {
    const currentItem = item?.dataItem ?? {};
    return (
        <td><input type="checkbox" className="uploadpartlistcheck quotename" checked={currentItem?.checked} onChange={(e) => {
            props?.updateCheckedItems(e?.target?.checked ?? false, item)
        }} /></td>
    )
}

const shareCommentsView = (row: any) => {
    return (
        <td className='k-table-td nowrap' title={row?.dataItem?.comments}>
            {row?.dataItem?.comments}
        </td>
    )
}


const QuantityColumnViewShareQuote = (row: any, props: any) => {
    return (
        <QuantityColumn isCommon={true} quantity={row?.dataItem?.partQty} partId={row?.dataItem?.id} onQuantityChange={props?.onQuantityChange} />
    )
}

const ViewHeaderDetail = (props: any) => {
    const checked = props?.selectedDetailItem?.quoteList?.length > 0 && (!(props?.selectedDetailItem?.quoteList?.find((s: any) => !(s?.checked ?? false))));
    return (
        <td><input disabled={!props?.selectedDetailItem?.quoteList?.length} type="checkbox" className="uploadpartlistcheck" checked={checked} onChange={(e) => {
            props?.updateCheckedItems(e?.target?.checked, undefined)
        }} /></td>
    )
}

const Action = (item: any, props: any, t: any) => {
    const anchor = useRef(null);
    const blurTimeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);
    const menuWrapperRef = useRef<any>();
    const [show, setShow] = useState(false);
    const onClick = () => {
        setShow(!show);
    };

    const handleSelect = (e: any, dataItem: any) => {
        if (e.item.text == t(RESOURCE.MyK_Label_ShoppingCart_Archive)) {
            props.archiveQuote(dataItem);
        }
        else if (e.item.text == t(RESOURCE.MyK_Label_ShoppingCart_Share)) {
            props.share(dataItem);
        }
        else {
            props.addToCart([dataItem]);
        }
        setShow(false);
    }

    const onFocusHandler = () => {
        clearTimeout(blurTimeoutRef.current);
        blurTimeoutRef.current = undefined;
    };

    const onBlurTimeout = () => {
        setShow(false);
        blurTimeoutRef.current = undefined;
    };

    const onBlurHandler = (event: any) => {
        clearTimeout(blurTimeoutRef.current);
        blurTimeoutRef.current = setTimeout(onBlurTimeout);
    };

    const onPopupOpen = () => {
        menuWrapperRef.current.querySelector('[tabindex]').focus();
    };
    const closePopup = () => {
        setShow(false);
    };

    return (

        <td className='actioncolumn'>
            <Popup
                anchor={anchor.current}
                show={show}
                onOpen={onPopupOpen}
                popupClass={'popup-content'}
                onClose={closePopup}
            >
                <div
                    onFocus={onFocusHandler}
                    onBlur={onBlurHandler}
                    tabIndex={-1}
                    ref={el => (menuWrapperRef.current = el)}
                >
                    <Menu vertical={true} style={{ display: 'inline-block' }} onSelect={(e: any) => handleSelect(e, item.dataItem)}>
                        <MenuItem text={t(RESOURCE.MyK_Label_ShoppingCart_Archive)} />
                        <MenuItem text={t(RESOURCE.MyK_Label_Share)} />
                        <MenuItem text={t(RESOURCE.MyK_Label_AddToCart)} />
                    </Menu>
                </div>
            </Popup>
            <button className="actionBtn" ref={anchor} onClick={onClick}><span className="fa fa-ellipsis-h"></span></button></td>
    )
}

const ActionCheckbox = (item: any, selectedItem: any, onSelectionChange: any) => {
    return (
        <td><input type="checkbox" className="uploadpartlistcheck quotename" checked={selectedItem?.filter((s: any) => s.quoteId == item?.dataItem?.quoteId)?.length > 0} onChange={(e: any) => onSelectionChange(e, item?.dataItem)} /></td>
    )
}

const ViewHeader = (data: any, selectedItem: any, selectAll: any) => {
    return (
        <><input disabled={!data.length} type="checkbox" className="uploadpartlistcheck" checked={data.length > 0 && data.length == selectedItem.length} onClick={(e: any) => selectAll(e)} /></>
    )
}

const QuoteName = (item: any, props: any) => {
    return (
        <td><span onClick={() => props?.onQuoteClick(item)} onKeyDown={() => { }} className='quotelink quotename'>{item?.quoteNumber}</span></td>
    )
}

const SharedDateView = (item: any, headercurrentuser: any) => {
    return (
        <td>{item.dataItem.createdUTCDate ? helperfunctions.getDateWithLocalFormat(item.dataItem.createdUTCDate, headercurrentuser?.userpreference?.culture) : ""}</td>
    )
}

const ViewedDateView = (item: any, headercurrentuser: any) => {
    return (
        <td>{item.dataItem.viewedDate ? helperfunctions.getDateWithLocalFormat(item.dataItem.viewedDate, headercurrentuser?.userpreference?.culture) : ""}</td>
    )
}

const ActionHeader = (t: any) => {
    return (<><span className="k-column-title">{t(RESOURCE.MyK_Label_ShoppingCart_Action)}</span></>)
}

const Sharedquotescontainer = (props: Iprops) => {
    const { data, onSelectionChange, selectAll, selectedItem } = props;
    const { t } = useTranslation();
    const { headercurrentuser }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
        }));

    const sharedquotesDetailscolumn = [
        {
            field: "Select",
            title: t(RESOURCE.MyK_Select),
            columnMenu: 'ColumnMenu',
            sortable: true,
            cell: (row: any) => {
                return ActionCheckboxDetail(row, props)
            },
            width: 75,
            style: { textAlign: 'center' },
            headerCell: () => ViewHeaderDetail(props)
        },
        {
            field: 'manufacturerName',
            title: t(RESOURCE.MyK_Label_ManufacturerName),
            sortable: true,
            width: 200,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
        {
            field: 'partNumber',
            title: t(RESOURCE.MyK_Grid_Part_Number),
            sortable: true,
            width: 160,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
        {
            field: 'description',
            title: t(RESOURCE.MyK_Grid_Description),
            sortable: true,
            width: 200,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
        {
            field: 'partQty',
            title: t(RESOURCE.MyK_Grid_Qty),
            cell: (row: any) => QuantityColumnViewShareQuote(row, props),
            sortable: true,
            width: 160,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
        {
            field: 'machine',
            title: t(RESOURCE.MyK_Grid_Machine),
            sortable: true,
            columnMenu: 'ColumnMenu',
            filterable: true
        },

    ]

    const [sharedquotesDetailscolumns, setSharedquotesDetailscolumn] = useState(sharedquotesDetailscolumn);

    useEffect(() => {
        setSharedquotesDetailscolumn(sharedquotesDetailscolumn)
    }, [props?.selectedDetailItem]);


    const sharedquotescolumns = [
        {
            field: 'Action',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Action),
            sortable: true,
            cell: (row: any) => {
                return Action(row, props, t)
            },
            width: 75,
            headerCell: (props: any) => ActionHeader(t),
            headerClassName:'actionMenuHeader',
        },
        {
            field: "Selectall",
            title: " ",
            columnMenu: 'ColumnMenu',
            sortable: true,
            cell: (row: any) => {
                return ActionCheckbox(row, selectedItem, onSelectionChange)
            },
            width: 75,
            style: { textAlign: 'center' },
            headerCell: () => ViewHeader(data, selectedItem, selectAll),
            headerClassName:'selectallHeader'
        },
        {
            field: 'quoteNumber',
            title: t(RESOURCE.MyK_Label_SC_Quote) + " #",
            cell: (row: any) => {
                return QuoteName(row?.dataItem, props)
            },
            sortable: true,
            width: 130,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
        {
            field: 'quoteName',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quote_Name),
            columnMenu: 'ColumnMenu',
            style: { textAlign: 'center' },
            sortable: true,
            width: 180,
            filterable: true
        },
        {
            field: 'totParts',
            title: t(RESOURCE.MyK_Label_SC_NoOfParts),
            sortable: true,
            width: 130,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
        {
            field: 'comments',
            title: t(RESOURCE.MyK_Label_Comments),
            width: 260,
            columnMenu: 'ColumnMenu',
            filterable: true,
            cell: shareCommentsView
        },
        {
            field: 'sharedWithCount',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Shared_With),
            sortable: true,
            width: 145,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
    ]

    const sharedNestedQuote = [
        {
            field: 'sharedToUserEmail',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Shared_With),
            sortable: true,
            columnMenu: 'ColumnMenu',
            filterable: true
        },
        {
            field: 'createdDate',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Shared_Date),
            columnMenu: 'ColumnMenu',
            filterable: true,
            cell: (row: any) => {
                return SharedDateView(row, headercurrentuser)
            },
            format: "{0: MM/dd/yyyy}",
            type: "date",
            filter: "date",
        },
        {
            field: 'viewDateFilter',
            title: t(RESOURCE.MyK_Label_ShoppingCart_View_Date),
            sortable: true,
            columnMenu: 'ColumnMenu',
            filterable: true,
            cell: (row: any) => {
                return ViewedDateView(row, headercurrentuser)
            },
            format: "{0: MM/dd/yyyy}",
            type: "date",
            filter: "date",
        }
    ]

    return (
        <SharedQuotes
            sharedquotescolumns={sharedquotescolumns}
            selectedSharedQuoteObject={props?.selectedDetailItem}
            onCommentChange={props?.onCommentChange}
            isDetailsLoading={props?.quoteDetailList?.loading}
            gridRef={props?.gridRef}
            mount={props?.mount}
            setMount={props?.setMount}
            addToCart={props.addToCart}
            share={props.share}
            archiveQuote={props.archiveQuote}
            onSelectionChange={props.onSelectionChange}
            selectAll={props.selectAll}
            selectedItem={props.selectedItem}
            setSelectedItem={props.setSelectedItem}
            sharedNestedQuote={sharedNestedQuote}
            sharedquotesDetailscolumns={sharedquotesDetailscolumns}
            showsharedDetails={props.showsharedDetails}
            isLoading={props.isLoading}
            data={props?.data}
            downloadAttachment={props?.downloadAttachment}
        />
    )

}

export default Sharedquotescontainer